export const lineClamp = (element: HTMLElement, originalText: string) => {
  const containerHeight = element.scrollHeight;
  const child = element.firstElementChild;

  if (child.innerHTML.includes('...')) {
    child.innerHTML = originalText;
  }
  while (child.scrollHeight > containerHeight) {
    const textArr = child.innerHTML.split(' ');
    textArr.pop();
    child.innerHTML = textArr.join(' ') + '...';
  }
};
